<template>
  <!--  <div>-->


  <b-form-group  label-for="user-name">
    <!--            <validation-provider-->
    <!--                #default="{ errors }"-->
    <!--                :name="fieldsData.name"-->
    <!--                :rules="fieldsData.required == 1 ? 'required' : ''">-->



    <!--    />-->
    <!--    <div>-->

    <label for="tags-basic" v-html="fieldsData.label[selectlang]"></label>
    <div class="row ">
      <div class="col-md-8 col-12 ">
    <b-form-input
        :required="isRequired(fieldsData.required)"
        :value="fieldsData.id"
        :placeholder="fieldsData.hint[selectlang]"
        :type="fieldsData.inputType"
        @input="UpdateValue($event)"
        :pattern="fieldsData.pattern"
        class="form-control "

    />
      </div>
      <div class="col-md-4 col-12 ">
    <button  type="button" v-html="this.fieldsData.btnAction.label[this.selectlang]" style="width: 100%"
             class="verifybtn" @click="actionverify(fieldsData.action.url,fieldsData.id,selectlang)"
             :disabled="!isEmailValid" ></button>
    </div>

    </div>
    <span v-if="loading" style="text-align: center"> loading...</span>
    <span v-if="istoastMessage" class="custom-toaster">{{ toastMessage }}</span>


<!--    <span v-if="isverifymsgshow" style="text-align: center;color: red">Please Verify Email</span>-->
    <b-form-input  v-model="isallowverifybtn" hidden="hidden" value=""/>
    <!--    </div>-->
    <small class="text-danger">{{ errors[0] }}</small>
    <!--            </validation-provider>-->
  </b-form-group>
  <!--  </div>-->
</template>

<script>
// import {ValidationProvider} from "vee-validate";
// import {required} from "@validations";
import { callAxiosWithHeader} from "@/main";

export default {
  components: {
    // ValidationProvider,
  },

  data() {
    return {
      istoastMessage:false,
      toastMessage: '',
      emailValue:'',
      loading:false,
      isallowverifybtn:0,
      buttonname:this.fieldsData.btnAction.label[this.selectlang],
      // isVerifyMsgShow:false,

      // errors: [],
      DataArray:{},
      // verifyviewmsg:'',
      // value: [],
      // required,
    };
  },
  props: ['fieldsData','selectlang'],
  created() {

    if(this.fieldsData.id !=''){
      this.$emit('verifybtndone',1);

    }
  },
  computed: {
    isEmailValid() {
      // Use a regex pattern to validate the email
      const emailPattern = new RegExp(this.fieldsData.pattern);
      return emailPattern.test(this.fieldsData.id);
    },

  },

  methods: {

    verifyviewmsgtoaster(message) {
      // Set the message
      this.istoastMessage=true;
      this.toastMessage = message;
      setTimeout(() => {
        this.istoastMessage=false;
        this.toastMessage = ''; // Clear the message after 3 seconds

      }, 3000); // Adjust the duration as needed
    },


    async actionverify(url,valueemail,lang){
      if(valueemail !=''){
        this.loading=true;
        const emaildata = {
          email: valueemail,
          'Content-Type': 'application/json'
        };
        const verifyData = await callAxiosWithHeader(url,'' , 'post', emaildata);
        // console.log('verifyData',verifyData);

        if(verifyData.status == true){
          let toastmsg=verifyData.message[lang];
          this.fieldsData.btnAction.label=verifyData.btnText;
          this.isallowverifybtn=1;
          this.$emit('verifybtndone',this.isallowverifybtn);
          this.loading=false;
          this.verifyviewmsgtoaster(toastmsg);


        }
        else{
          let toastmsg=verifyData.message[lang];
          this.buttonname=verifyData.btnText[lang];
          this.fieldsData.btnAction.label=verifyData.btnText;
          this.isallowverifybtn=0;
          this.$emit('verifybtndone',this.isallowverifybtn);
          this.loading=false;
          this.verifyviewmsgtoaster(toastmsg);

        }

      }



    },


    isRequired(requiredValue) {

      // Check if fieldsData.required is equal to 1
      return requiredValue == 1;
    },
    UpdateValue(value){
      // this.buttonname=this.fieldsData.btnAction.label[this.selectlang];
      this.fieldsData.btnAction.label=this.fieldsData.btnAction.oldlabel;
      this.isallowverifybtn=0;
      // alert(this.isallowverifybtn);
      // console.log(value);
      this.$emit('input',value)
      this.$emit('verifybtndone',this.isallowverifybtn);
    },


    //
    // onlyNumber($event) {
    //   //console.log($event.keyCode); //keyCodes value
    //   let keyCode = $event.keyCode ? $event.keyCode : $event.which;
    //   if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
    //     // 46 is dot
    //     $event.preventDefault();
    //   }
    // },



  }
}
</script>

<style>
.verifybtn{
  width: 100px;
  margin: 0px 2px;
  border-radius: 10px;
  padding: 5px;
  border: unset;
  color: white !important;

}
.custom-toaster {
  left: 50%;
  right: 0;
  position: relative;
  transform: translateX(-50%);
  padding: 2px;
  border-radius: 5px;
  border: 1px solid black;

  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
/* Add your styles here */
</style>
